import React, { useContext } from "react";
import { DatosInicioContext } from "../../context/DatosInicioContext";
import { DarkModeContext } from "../../context/DarkModeContext";
import BienvenidoPanel from "../../components/comunes/BienvenidoPanel";
import Footer from "../../components/comunes/Footer";
import DatosContabilidad from "../../components/comunes/DatosContabilidad";
import ScrollToTopButton from "../../components/comunes/ScrollToTopButton";
import Impuesto2Cards from "../../components/comunes/Impuesto2Cards";
import TablaContabilidadArchivos from "../../components/comunes/TablaContabilidadArchivos";
import "./Contabilidad.css";
import "./AliadoResponsive.css";

const Contabilidad = () => {
  const { datosContabilidadContext } = useContext(DatosInicioContext);
  const { darkMode } = useContext(DarkModeContext);
  const today = new Date();

  return (
    <div className={darkMode ? "aliado-contabilidad aliado-contabilidad-dark" : "aliado-contabilidad"} translate="no">
      <main className="aliado-contabilidad-shell">
        <header className="aliado-contabilidad-header">
          <div>
            <span className="aliado-contabilidad-kicker">CRM Aliado</span>
            <h1>Contabilidad</h1>
          </div>
          <div className="aliado-contabilidad-date">
            {today.toLocaleDateString("es-AR")} |{" "}
            {today.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" })}
          </div>
        </header>
        <div className="aliado-contabilidad-filter">
          <BienvenidoPanel />
        </div>
        <ScrollToTopButton />
        <div className="aliado-contabilidad-kpis">
          <DatosContabilidad datosBack={datosContabilidadContext} />
        </div>
        <section className="aliado-contabilidad-main d-lg-grid d-none">
          <div>
            <Impuesto2Cards datosBack={datosContabilidadContext} />
          </div>
          <div className="aliado-contabilidad-table-card">
            <TablaContabilidadArchivos />
          </div>
        </section>
        <section className="aliado-contabilidad-main d-grid d-lg-none">
          <div>
            <Impuesto2Cards datosBack={datosContabilidadContext} />
          </div>
          <div className="aliado-contabilidad-table-card">
            <TablaContabilidadArchivos />
          </div>
        </section>
        <div className="aliado-contabilidad-footer">
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default Contabilidad;
